import "@/styles/styles.scss";
import * as FullStory from "@fullstory/browser";
import App from "@/App.vue";
import constants from "@/utils/constants";
import i18n from "@/i18n";
import { on as lsOn } from "local-storage";
import { request } from "leatherman-js";
import router from "@/router";
import store from "@/store";
import Vue from "vue";
import VueClipboard from "vue-clipboard2";
import VueCompositionApi from "@vue/composition-api";

if (process.env.VUE_APP_FULLSTORY_ID) {
  FullStory.init({
    orgId: process.env.VUE_APP_FULLSTORY_ID,
    debug: !!process.env.VUE_APP_FULLSTORY_DEBUG,
  });
  Vue.prototype.$FullStory = FullStory;
}

if (process.env.VUE_APP_API_URL) {
  request.setBaseUrl(process.env.VUE_APP_API_URL);
}

request.setAuthResponseListener((token) => {
  store.dispatch("auth/setToken", token);
});

const checkTokenChange = (newToken, oldToken) => {
  console.log("token updated", { newToken, oldToken });
  if (newToken.user !== oldToken.user || newToken.client !== oldToken.client) {
    console.log("refresh user");
    location.replace("/");
    location.reload();
  }
};

lsOn(constants.AUTH_TOKEN_KEY, checkTokenChange);

Vue.use(VueClipboard);

Vue.use(VueCompositionApi);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
